export default __webpack_public_path__ + "static/media/website.a6063b89.svg";